import React from 'react';
import { Link } from 'react-router';
import cls from 'clsx';
import { Img, Price } from '@link/share/components';
import { VerticalProductCardProps } from './VerticalProductCard.types';
import styles from './verticalProductCard.module.css';

const VerticalProductCard: React.FC<VerticalProductCardProps> = ({
  image,
  title,
  tags = [],
  priceInfo,
  needApproximate = true,
  to,
  target = false,
  className
}) => {
  return (
    <Link
      to={to}
      target={target ? '_blank' : undefined}
      rel={target ? 'noopener noreferrer' : undefined}
    >
      <div className={cls(styles.card, className)}>
        <div className={styles.imageWrapper}>
          <Img className={styles.image} src={image} alt={title} />
        </div>
        <div className={styles.content}>
          <h3 className={styles.title}>{title}</h3>
          {tags.length > 0 && (
            <div className={styles.tags}>
              {tags.map((tag, index) => (
                <span key={index} className={styles.tag}>
                  {tag}
                </span>
              ))}
            </div>
          )}
          <div className={styles.footer}>
            <Price
              amount={priceInfo.amount}
              currencyCode={priceInfo.currencyCode}
              needApproximate={needApproximate}
              formatOptions={{ smallCurrencyCode: true }}
              className={styles.price}
            />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default VerticalProductCard;
